<template>
  <div>
    <div>
      <h2Title title="薪酬组信息">
        <backBtn @reOnClick="reOnClick"></backBtn>
      </h2Title>
    </div>
    <div id="content" v-loading="loading">
      <el-form
        style="margin-top:16px;display:flex;height: 50px;"
        :model="payGroupForm"
        ref="payGroupForm"
        :rules="rules"
        label-width="106px"
        inline-message="true"
      >
        <el-form-item label="薪酬组名称" prop="groupName">
          <el-input v-model="payGroupForm.groupName" style="width:250px;" placeholder="请输入薪酬组名称"></el-input>
        </el-form-item>
        <!-- 分支机构的薪酬组不展示上级 -->
        <el-form-item label="上级薪酬组" prop="superGroup" v-if="payGroupForm.ifBranch != '10020001' && !(groupId&&groupId!='')">
<!--          <el-select v-model="payGroupForm.superGroup" style="width:250px;"  placeholder="请选择上级薪酬组">-->
<!--            <el-option-->
<!--              v-for="item in payGroupData"-->
<!--              :key="item.id"-->
<!--              :label="item.name"-->
<!--              :value="item.id">-->
<!--            </el-option>-->
<!--          </el-select>-->
          <ciic-tree-select style="width:250px;" :multiple="false" :props="defaultGroupProps" :expand="true"
                            :showFilter="false" :options="payGroupData" :value="payGroupForm.superGroup"
                            @getValue="selectSuperGroup" v-model="payGroupForm.superGroup" placeholder="请选择上级薪酬组" ></ciic-tree-select>
        </el-form-item>
      </el-form>
      <div id="box">
        <div class="boxt-top">
          <div>
            <div style="width:280px;text-align:center">
              适用机构范围
            </div>

          </div>
          <div class="flex boxTop">
            <div>
              <div class="topLeft">
														<span>
															适<br/>用<br/>机<br/>构

														</span>

              </div>
              <div class="topRight">
                <div class="item"  v-for="(item,i) in orgDatas" :key="item.id">

                  <div >
                    <img src="@/assets/img/salarySet/guanbi.png" alt="" @click="del(i)" srcset="">
                    <img  src="@/assets/img/salarySet/dept.png" alt="" srcset="">
                    <!-- <img v-if="item.type=='person'" src="@/assets/img/salarySet/person.png" alt="" srcset=""> -->
                  </div>
                  <div>
                    {{item.orgName}}
                  </div>
                </div>
              </div>

            </div>
            <div>
              <div class="topLeft">
														<span>
                            排<br/>除<br/>人<br/>员
														</span>
              </div>
              <div class="topRight">
                <div class="item"  v-for="(item,i) in outPerDatas" :key="item.id" >

                  <div>
                    <img src="@/assets/img/salarySet/guanbi.png" alt="" @click="del2(i)" srcset="">
                    <!-- <img v-if="item.type=='dept'" src="@/assets/img/salarySet/dept.png" alt="" srcset=""> -->
                    <img  src="@/assets/img/salarySet/person.png" alt="" srcset="">
                  </div>
                  <div>
                    {{item.empName}}
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div>
            <p>
              <span @click="openOrg()">选取机构</span>
            </p>
            <p>
              <span @click="openPerson('out')">选取排除人员</span>
            </p>
          </div>
        </div>
        <div class="box-bot">
          <div>
            <div style="width:280px;text-align:center">
              适用人员范围
            </div>

          </div>
          <div class="flex">
            <div class="item"  v-for="(item,i) in perDatas" :key="item.id">
              <div>
                <img src="@/assets/img/salarySet/guanbi.png" alt="" @click="del1(i)" srcset="">
                <img src="@/assets/img/salarySet/person.png" alt="" srcset="">
              </div>
              <div>
                {{item.empName}}
              </div>
            </div>
          </div>
          <div>
            <p>
              <span @click="openPerson('in')">选取人员</span>
            </p>
          </div>
        </div>
      </div>

    </div>
    <div class="warn">
      温馨提示：该薪酬组对应薪资批次的人员范围为所选机构及下级机构的所有员工 和 已选取员工；
    </div>
    <div id="save">
      <el-button type="primary" @click="saveOrUpdate()">保存</el-button>
    </div>
    <el-dialog
      v-dialog-drag
      ref="selectPerson"
      width="70%"
      id="selectPerson"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选取人员"
      :visible.sync="dialogheaderVisible"
      v-if='dialogheaderVisible'
      :destroy-on-close="true"
    >
      <selectPerson :perDatas="perDatas"
                    :cusId="cusId"
                    :outPerDatas="outPerDatas"
                    :orgDatas="orgDatas"
                    :state="personState"
                    v-on:personDatas="personClick"
      />
    </el-dialog>
    <el-dialog
      v-dialog-drag
      ref="selectOrg"
      width="500px"
      id="selectOrg"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="选取机构"
      :visible.sync="dialogorgVisible"
      v-if='dialogorgVisible'
      :destroy-on-close="true"
    >
      <selectOrg :vdata="vdata"
      :cusId="cusId"
      :orgDatas="orgDatas"
      v-on:orgTreeDatas="orgTreeClick"
      :ifBranch="payGroupForm.ifBranch"
      :orgId="payGroupForm.orgId"></selectOrg>
    </el-dialog>
  </div>

</template>

<script>

  import backBtn from "@/wage-components/back-btn/back-btn.vue";
	import h2Title from "@/views/wage/set/payGroupSetting/h2Title.vue";

  import selectPerson from "@/views/wage/set/payGroupSetting/selectPerson.vue";
  import selectOrg from "@/views/wage/set/payGroupSetting/selectOrg.vue";
  import { mapGetters } from 'vuex';
  import {deepCopy,getTreePid,getTreeChildrenId} from "@/util/util";
  import { treeToArray,buildTree } from "@/util/common";
  import {getPayGroupPIDData,getPayGroupData,getGroupDatas,saveGroupDatas,getWageGroupTree} from  "@/api/wage/payGroup";
  import CiicTreeSelect from "@/components/ciic/ciic-tree-select/ciic-tree-select";
  import { validateCheckGroupName } from "@/util/validate";


  export default {
    name: "payGroupDetail",
    components: {h2Title,selectPerson,selectOrg,CiicTreeSelect,backBtn},
    computed: {
      ...mapGetters([
        'dicts',
      ]),
    },
    created(){
      //this.orgTreeData = window.MOCK_TREE_DATA_LIST.slice(0);
      // this.getList();
      //this._getGroupList();
      this.cusId = this.$route.query.cusId;
      console.log("路由传过来的this.$route.query.cusId=",this.$route.query.cusId);
      console.log("路由传过来的this.$route.query.id=",this.$route.query.id);
      this._getGroupInfo();//薪酬组数据
      this._getWageGroupTree();//获取上级薪酬组
    },
    mounted(){
      this.groupId = this.$route.query.id;
    },
    data(){
      return{
        dialogheaderVisible:false,
        dialogorgVisible:false,
        personState:"",
        loading:false,
        showList:[true,false],
        editList:[true,false],
        formData:{},
        oldFormData:{},
        baseForm:{},
        operationList:[],
        taxInfoList:[],
        salaryTemplatelist:[],
        groupList:[],
        dialogFormVisible:false,
        dialogStatus:'',
        payGroupForm:{
          superGroup : this.superGroup,
        },
        operationModeId:'',
        cusId:'',
        rules: {
          groupName: [
            {required: true, message: '请输入薪酬组名称', trigger: 'blur'},
            {max:20, message: '不能超过20个字符', trigger: 'blur'},
          ],
          superGroup: [
            {required: true, message: '请输入上级薪酬组', trigger: 'blur'},
          ],
        },
        validateForm: {},
        dynamicTags: ['标签一', '标签二', '标签三'],
        orgDialogTitle: "",
        orgDialogVisible: false,
        orgTreeData: [],
        personDialogTitle: "",
        personDialogVisible: false,
        personTreeData: [],
        repersonDialogTitle: "",
        repersonDialogVisible: false,
        repersonTreeData: [],
        defaultProps: {
          children: 'children',
          label: 'agencyName',
          value: 'id',
        },
        defaultGroupProps: {
            children: 'children',
            label: 'groupName',
            value:'id',
        },
        selectedNodeInfo: {
          children:[]
        },
        payGroupData:[],
        orgDatas:[],
        perDatas:[],
        outPerDatas:[],
        vdata:'123',
        showTip:true,
        groupId:''
      }
    },

    methods:{
      openPerson(e) {
        this.dialogheaderVisible = true;
        this.personState = e;
        console.log("传递已存在人员数据----",this.perDatas);
      },
      openOrg() {
        this.dialogorgVisible = true
      },
      //删除选取机构
      del(i) {
        if(this.payGroupForm.ifBranch=='10020001' && this.orgDatas[i].id == this.payGroupForm.orgId){
          this.$message.warning('无法删除该机构')
          return;
        }
        this.$confirm('此操作将删除该项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.orgDatas.splice(i,1);
        }).catch(() => {

        });
      },
      //删除选取人员
      del1(i) {
        this.$confirm('此操作将删除该项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.perDatas.splice(i,1);
        }).catch(() => {

        });

      },
      //删除排除人员
      del2(i) {
        this.$confirm('此操作将删除该项, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.outPerDatas.splice(i,1);
        }).catch(() => {

        });

      },
      saveOrUpdate() {
        this.$refs.payGroupForm.validate((valid) => {
          if (valid) {
            this.save();
          } else {
            this.$message.error("请填入正确的信息");
            return false;
          }
        });
      },
      save() {
        this.loading = true;
        let o = {
            'outPersonData':this.outPerDatas,
            'personData':this.perDatas,
            'orgData':this.orgDatas,
            'groupData':this.payGroupForm
          };
        saveGroupDatas(o).then((res) => {
          this.loading = false;
          console.log("薪酬组List====",res.data.data)
          let rs=res.data;
          if(rs.code==0){
            this.$message.success("保存成功");
            this.reOnClick();
            // console.log('a'+ JSON.stringify(this.formulaItemList))
          }else{
            this.$message.error('保存失败，请联系管理员')
          }
        });
      },
      // 取消
      cancelHandler(formName,index) {
        // 关闭修改
        this.changeEdit(index);
        // 并把修改后的值设置成原来的值
        this.formData = JSON.parse(JSON.stringify(this.oldFormData));
      },
      changeEdit(index){
        let newValue;
        this.editList[index] === "true"?newValue = "false":newValue = "true";
        this.formData = JSON.parse(JSON.stringify(this.oldFormData));
        console.log("最新的值",this.formData);
        console.log("旧的值",this.formData);
        this.$set(this.editList, index, newValue)
      },
      reOnClick() {
        const query = {}
        this.$router.push({ path: '/wageSet/step2', query});
      },
      closeTag(tag){
        console.info("关闭标签事件。。。。。");
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      },
      toOrgPage(){
        this.orgDialogVisible = true;
        this.orgDialogTitle = "选取机构";
      },
      toPersionPage(){
        this.orgDialogVisible = true;
        this.orgDialogTitle = "选取人员";
      },
      toRePersionPage(){
        this.orgDialogVisible = true;
        this.orgDialogTitle = "选取人员";
      },
      selectChangeEvent ({ selection }) {
        console.info(`勾选${selection.length}个树形节点`, selection)
      },

      //点击左侧树节点事件
      getNodeData(data) {
        if(data.parentId != "-1"){
          this.formLoading = true
        }
        this.getAgencyMember(data.id)
        this.formStatus = 'update';
        this.resetForm('form')
        this.selectedNodeInfo = JSON.parse(JSON.stringify(data));
        this.form = JSON.parse(JSON.stringify(deepCopy(data)));
        // 获取当前节点父ID
        this.pNode = getTreePid(data.id, this.treeData);
        if(this.pNode != undefined){
          this.form.parentId = this.pNode.id;
          this.form.parentName = this.pNode.agencyName;
        }
        // this.getAgencyDetail(data.id)
        // 获取当前节点子节点ID集合
        this.childrenIds = getTreeChildrenId(this.form);
        this.removeChildren(this.childrenIds)

      },
      //获取某个机构下的成员数量
      getAgencyMember(agencyId){
        getAgencyMember(agencyId).then(res => {
          this.agencyMember = res.data.data
        }).catch(() => {
        });
      },
      //去掉当前元素的所有子节点
      removeChildren(childIds){
        let arr = treeToArray(deepCopy(this.treeData))
        childIds.forEach(item => {
          arr.forEach((data, index) => {
            if(data.id === item){
              arr.splice(index, 1)
            }
          })
        })
        this.slectreeData = buildTree(arr, 'id', 'parentId')
      },
      // 获取模板项数据类型
      _getGroupList: function(){
        getPayGroupPIDData().then(res=>{
          let rs=res.data
          if(rs.code==0){
            // this.options=
            if(this.tenantInfo.tenantId!='0'){
              arr[0].codeItemName='数值'
              arr.push(arr1[0])
              this.options=rs.data
            }else{
              this.options=rs.data
            }
            // console.log('a'+ JSON.stringify(this.formulaItemList))
          }else{
            this.$message.error('获取值类型出现问题')
          }
        })
      },

      _getWageGroupTree(){
          getWageGroupTree(this.cusId).then(res=>{
              this.payGroupData = res.data.data;//查询机构树
          })
      },
      selectSuperGroup({ valueId, valueTitle, name, node }){
          this.payGroupForm.superGroup = valueId;
          return valueId;
      },
      _getGroupInfo(){
        let groupId=this.$route.query.id;
        if (groupId) {
          console.info("groupId----"+groupId)
          getGroupDatas(groupId).then(res => {
            console.log("薪酬组数据6-10===res=",res)
            this.loading = false;
            if (res.data.code === 0) {
              this.payGroupForm= res.data.data.payGroupForm;
              console.info("403薪酬数据组payGroupForm-----",this.payGroupForm);
              this.perDatas= res.data.data.perList;
              console.info("403薪酬数据组perDatas-----",this.perDatas);
              this.outPerDatas= res.data.data.outPerList;
              console.info("405薪酬数据组outPerDatas-----",this.outPerDatas);
              this.orgDatas= res.data.data.orgList;
              console.info("407薪酬数据组orgDatas-----",this.orgDatas);
            } else {
              this.$message.error("服务器异常");
            }
          });
        }

      },
      orgTreeClick(e1){
        this.dialogorgVisible=e1.dialog;
        if(e1.org.length==0){
          let li = [
            {id:e1.org.id,name:e1.org.name},
          ]
          this.orgDatas = this.orgDatas.concat(li);
        }else{
          this.orgDatas =  e1.org;
         /* var selectArr =  this.orgDatas;
          e1.org.map(function (item) {
            selectArr.push(item)
          })
          this.orgDatas = selectArr;*/
        }
        console.log(this.orgDatas)
      },
      personClick(e1){
        console.log("选取人员后-----",e1);
        if(this.personState=='in'){
          console.log('排除人员:',this.outPerDatas)
          let k = false;
          //比较适用人员和排除人员
          e1.data.forEach(per => {
            this.outPerDatas.forEach(outPer=>{
              console.log(per.id,outPer.id)
              if(k || per.id == outPer.id){
                k = true;
              }
            },per)
          });
          if(k){
            this.$message.warning('适用人员和排除人员不能重复')
            return
          }

          //this.perDatas = e1.data;
          var selectArr = this.perDatas;
          e1.data.map(function (item) {
            selectArr.push(item)
          })
          this.perDatas = selectArr;
        }else{
          console.log('选取人员:',this.perDatas)
          let k = false;
          //比较适用人员和排除人员
          e1.data.forEach(outPer => {
            this.perDatas.forEach(per=>{
              if(k || per.id == outPer.id){
                k = true;
              }
            },outPer)
          });
          if(k){
            this.$message.warning('适用人员和排除人员不能重复')
            return
          }
          var selectArr = this.outPerDatas;
          e1.data.map(function (item) {
            selectArr.push(item)
          })
          this.outPerDatas = selectArr;
        }
        this.dialogheaderVisible=e1.dialog;

      },
    }
  };
</script>

<style scoped>
  .form{
    display: flex;
    justify-content: flex-start;
    padding-top: 12px;
    padding-bottom: 10px;
    width: 100%;
  }
  .el-form-item{
    width: 400px;
  }
  #content>div{
    border:1px solid rgba(221,221,221,1);
    border-top:none;
  }
  #content >>> .el-form-item{
    margin-bottom: 0;
  }
  #box>div{
    display: flex;
  }
	#content >>> .el-form-item__error--inline{
		top: -6px;
	}
	#content >>> .el-form-item:nth-of-type(2) .el-form-item__error--inline{
		top: -16px;
	}
  #box>div>div:nth-of-type(1){
    width:280px;
    border-right:1px solid rgba(221,221,221,1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:14px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:600;
    color:rgba(0,0,0,1);
    border-top:1px solid rgba(221,221,221,1);
  }
  #box>div>div:nth-of-type(2){
    flex-grow: 1;
    min-height: 120px;
    border-top:1px solid rgba(221,221,221,1);
    display: flex;
    flex-wrap: wrap;
    padding:0 20px;
    box-sizing: border-box;
  }

  #box>div>div:nth-of-type(3){
    width: 260px;
    border-left:1px solid rgba(221,221,221,1);
    border-top:1px solid rgba(221,221,221,1);
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

  }
  #box>div>div:nth-of-type(3) p{
    width: 260px;
    text-align: center
  }
  #box>div>div:nth-of-type(3) p span{
    font-size:12px;
    font-family:PingFangSC-Medium,PingFang SC;
    font-weight:500;
    color:rgba(64,158,255,1);
    cursor: pointer;
  }
  .item>div:nth-of-type(1){
    position: relative;
    width: 64px;
    height: 64px;
    margin: 0 auto 7px;
  }
  .item>div:nth-of-type(1) img:nth-of-type(1){
    position: absolute;
    right: 0;
    top: 4px;
    cursor: pointer;
  }
  .item>div:nth-of-type(2){
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(51,51,51,1);
  }
  .item{
    width: 118px;
    text-align: center;
    margin: 20px 0
  }
  .warn{
    font-size:12px;
    font-family:PingFangSC-Regular,PingFang SC;
    font-weight:400;
    color:rgba(232,60,44,1);
    line-height:17px;
    padding: 6px 10px
  }
  #save{
    padding: 10px 0 16px;
    text-align: center;
  }
  .boxTop{
    flex-direction: column;
  }
  .boxTop>div{
    display:flex;
    align-items: stretch;
  }
  .boxTop>div>div:nth-of-type(1) span{
    width: 44px;
    display: inline-block;
    font-size:14px;
    font-weight:400;
    color:rgba(0,0,0,1);
    text-align: center;
    padding: 12px 0;
  }
  #box>div>div.boxTop:nth-of-type(2){
    padding: 0;
  }
  #box>div>div.boxTop:nth-of-type(2)>div:nth-of-type(1){
    border-bottom: 1px solid rgba(221,221,221,1);
  }
  #box>div>div.boxTop:nth-of-type(2)>div .topLeft{
    border-right: 1px solid rgba(221,221,221,1);
    display: flex;
    align-items: center;
  }
  #box>div>div.boxTop:nth-of-type(2)>div .topRight{
    display: flex;
    flex-wrap: wrap;
    padding:0 20px;
  }

</style>
